module.exports = __webpack_public_path__ + "img/7eleven.30ccbb90.png";